// extracted by mini-css-extract-plugin
export default {"-large":"IuXG2FCtmprqhvTo3qSN","container":"OBXF69OgLEyWlnb7UhKu"};